import React from "react";
import "../../styles/LoginModalScreen.css";
import blueLogo from "../../images/blueLogo.png";
import { useSelector, useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Link, useHistory } from "react-router-dom";
import { loginAction } from "../../redux/actions/loginAction";
import { logoutAction } from "../../redux/actions/logoutAction";
import config from "../../config/config";

const LoginModalScreen = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const logInResponse = useSelector((state) => state.loginReducer);

  const [userDetails, setUserDetails] = React.useState({
    email: "",
    password: "",
  });

  const onDetailsChange = (e) => {
    let obj = {};
    obj[e.target.id] = e.target.value;
    setUserDetails({
      ...userDetails,
      ...obj,
    });
  };

  const redirectToHybris = () =>
    (window.location.href = `/${config.LOCALE}/register?target=${config.BASE_URL}`);

  const loginCLicked = (e) => {
    e.preventDefault();
    dispatch(loginAction(userDetails));
    setUserDetails({
      email: "",
      password: "",
    });
  };

  const logoutClicked = (e) => {
    e.preventDefault();
    dispatch(logoutAction());
    history.push("/");
    addToast("You are logged out successfully!", {
      appearance: "success",
      autoDismiss: true,
    });
  };

  const closeLoginModal = (e) => {
    e.preventDefault();
    dispatch({ type: "LOGIN_MODAL_CLOSE" });
  };

  return (
    <div className="login-modal-wrapper">
      <div className="login-modal-close-icon" onClick={closeLoginModal}>
        <span>
          <i className="fa fa-times"></i>
        </span>
      </div>
      <div className="login-modal">
        <div
          className="login-modal-close-icon-mobile"
          onClick={closeLoginModal}
        >
          <span>
            <i className="fa fa-times"></i>
          </span>
        </div>
        <div className="logo-container">
          <Link to="/">
            <img src={blueLogo} alt="vet-logo" />
          </Link>
          .
        </div>
        <p className="login-modal-text">
          {logInResponse.isLoggedIn
            ? `Hey,${logInResponse.email} ${logInResponse.firstName} ${logInResponse.lastName}! You're already logged in.`
            : "To continue, log in to VetConsult"}
        </p>
        {logInResponse.isLoggedIn ? (
          <div className="user-loggedin-text">
            <Link to="/subscription">
              <p>Buy Subscription</p>
            </Link>
            <Link to="/">
              <p>Go To Home</p>
            </Link>
            <p onClick={logoutClicked} style={{ cursor: "pointer" }}>
              Logout
            </p>
          </div>
        ) : (
          <div className="login-modal-sections">
            <div className="login-modal-sec1">
              {logInResponse.isError ? (
                <div className="error-label">
                  <p>Incorrect Username or Password</p>
                </div>
              ) : null}
              <form onSubmit={loginCLicked}>
                <div className="input-row">
                  <p>Email Address</p>
                  <input
                    id="email"
                    type="email"
                    name="email"
                    value={userDetails.email}
                    onChange={onDetailsChange}
                    required
                  />
                </div>
                <div className="input-row">
                  <p>Password</p>
                  <input
                    id="password"
                    type="password"
                    name="password"
                    value={userDetails.password}
                    onChange={onDetailsChange}
                    required
                  />
                </div>
                <div className="login-button-div">
                  <button type="submit" className="login-button">
                    Login
                  </button>
                </div>
                {/* <div className="remember-check-div">
                                    <input type="checkbox" id="rememberCheck" name="rememberCheck" />
                                    <label for="rememberCheck" className="remember-check-label">Remember me</label>
                                </div> */}
              </form>
            </div>
            {window.location.href
              .split("/")
              [window.location.href.split("/").length - 1].trim()
              .toLowerCase() === "non-free-topic" ? null : (
              <div className="login-modal-sec2">
                <div className="signup-button-div">
                  <p>Don’t have an account?</p>
                  <button className="signup-button" onClick={redirectToHybris}>
                    Signup for VetConsult
                  </button>
                </div>
                <div className="forgot-text">
                  <a
                    href={`/${config.LOCALE}/forgot-password?target=${config.BASE_URL}`}
                  >
                    <p>Forgot Password?</p>
                  </a>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default LoginModalScreen;
